//@ts-ignore
/* eslint-disable */
import React from 'react';
import './styles.scss'


const TransitionLayoutNew = ({children}) => {
  return(
    <div className={'transitionLayout'}>
      {children}
    </div>
  )
}

export default TransitionLayoutNew;